"use strict";

// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(void 0);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXROYW5vU2Vjb25kcyIsImhydGltZSIsImxvYWRUaW1lIiwibW9kdWxlTG9hZFRpbWUiLCJub2RlTG9hZFRpbWUiLCJ1cFRpbWUiLCJwZXJmb3JtYW5jZSIsIm5vdyIsIm1vZHVsZSIsImV4cG9ydHMiLCJwcm9jZXNzIiwiaHIiLCJ1cHRpbWUiLCJEYXRlIiwiZ2V0VGltZSJdLCJzb3VyY2VzIjpbIi4uL3NyYy9wZXJmb3JtYW5jZS1ub3cuY29mZmVlIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7QUFBQTtFQUFBLElBQUFBLGNBQUEsRUFBQUMsTUFBQSxFQUFBQyxRQUFBLEVBQUFDLGNBQUEsRUFBQUMsWUFBQSxFQUFBQyxNQUFBO0VBQUEsSUFBRyxPQUFBQyxXQUFBLG9CQUFBQSxXQUFBLGFBQWlCQSxXQUFXLENBQUNDLEdBQWhDO0lBQ0VDLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQjthQUFHSCxXQUFXLENBQUNDLEdBQVo7SUFBSDtHQURuQixNQUVLLElBQUcsT0FBQUcsT0FBQSxvQkFBQUEsT0FBQSxhQUFhQSxPQUFPLENBQUNULE1BQXhCO0lBQ0hPLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQjthQUFHLENBQUNULGNBQUEsS0FBbUJJLFlBQXBCLElBQW9DO0lBQXZDO0lBQ2pCSCxNQUFBLEdBQVNTLE9BQU8sQ0FBQ1QsTUFBQTtJQUNqQkQsY0FBQSxHQUFpQixTQUFqQkEsZUFBQSxFQUFpQjtNQUNmLElBQUFXLEVBQUE7TUFBQUEsRUFBQSxHQUFLVixNQUFBO2FBQ0xVLEVBQUcsR0FBSCxHQUFRLEdBQVIsR0FBY0EsRUFBRztJQUZGO0lBR2pCUixjQUFBLEdBQWlCSCxjQUFBO0lBQ2pCSyxNQUFBLEdBQVNLLE9BQU8sQ0FBQ0UsTUFBUixLQUFtQjtJQUM1QlIsWUFBQSxHQUFlRCxjQUFBLEdBQWlCRSxNQUFBO0dBUjdCLE1BU0EsSUFBR1EsSUFBSSxDQUFDTixHQUFSO0lBQ0hDLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQjthQUFHSSxJQUFJLENBQUNOLEdBQUwsS0FBYUwsUUFBQTtJQUFoQjtJQUNqQkEsUUFBQSxHQUFXVyxJQUFJLENBQUNOLEdBQUw7R0FGUjtJQUlIQyxNQUFNLENBQUNDLE9BQVAsR0FBaUI7YUFBTyxJQUFBSSxJQUFBLEVBQU0sQ0FBQ0MsT0FBUCxFQUFKLEdBQXVCWixRQUFBO0lBQTFCO0lBQ2pCQSxRQUFBLEdBQWUsSUFBQVcsSUFBQSxFQUFNLENBQUNDLE9BQVAiLCJpZ25vcmVMaXN0IjpbXX0=